export const ROLE_IDENTIFIERS = {
  ADMIN: "admin",
  EVENTS_ADMIN: "events-admin",
  ORGANIZER: "organizer",
  EVENTS_ORGANIZER: "events-organizer",
} as const;

export const ROLE_LABELS = {
  ADMIN: "ADMIN",
  ORGANIZER: "ORGANIZER",
  UNKNOWN: "UNKNOWN",
} as const;

export const ADMIN_ROLE_IDENTIFIERS = [
  ROLE_IDENTIFIERS.ADMIN,
  ROLE_IDENTIFIERS.EVENTS_ADMIN,
] as const;

export const ORGANIZER_ROLE_IDENTIFIERS = [
  ROLE_IDENTIFIERS.ORGANIZER,
  ROLE_IDENTIFIERS.EVENTS_ORGANIZER,
] as const;

export type RoleLabel = (typeof ROLE_LABELS)[keyof typeof ROLE_LABELS];
